import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Pagination from "react-js-pagination";
import Input from "../../component/Input";
import Community from "./Community";

import * as APIS from "../../utils/service";
import { useDispatch } from "react-redux";
import { close, open } from "../../redux/popupSlice";
import moment from "moment";

const FreeCommunity = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [params,] = useSearchParams();

    const [boardList, setBoardList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(10);

    const handlePageChange = (pageNumber) => {
        navigate("/FreeCommunity?page=" + pageNumber)
    };

    const [dateType, setDateType] = useState(0);
    const [searchType, setSearchType] = useState(1);
    const [searchValue, setSearchValue] = useState("");

    const [noticeList, setNoticeList] = useState([]);

    const loadList = (pageCount) => {
        let sender = {
            page: pageCount ? pageCount : 1,
            limit: limit,
            dateType: Number(dateType),
            textType: Number(searchType),
            text: searchValue
        };

        APIS.postData('/v1/community/list', sender).then(({ data }) => {
            if (data) {
                setBoardList(data?.list)
                setTotalCount(data?.totalCount)
                setPage(data?.page);
            }
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: '리스트를 가져올 수 없습니다.',
                    title: '알림',
                    button: "확인",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );
        }).finally(() => {
        });
    }

    const searchFunc = () => {
        if (params.get("page") != 1) {
            let pageNum = Number(params.get("page"))
            if (!isNaN(pageNum) && pageNum != 1) {
                navigate("/FreeCommunity?page=1")
            } else {
                loadList();
            }
        } else {
            loadList();
        }
    }

    useEffect(() => {
        if (params.get("page")) {
            let pageNum = Number(params.get("page"))
            if (!isNaN(pageNum)) {
                loadList(pageNum);
            } else {
                loadList();
            }
        } else {
            loadList();
        }
    }, [params])


    const loadNotice = () => {

        APIS.postData('/v1/community/notice', { type: 1 }).then(({ data }) => {
            setNoticeList(data);
        }).catch(({ response }) => {
            setNoticeList(null);
        })
    }

    useEffect(() => {
        loadNotice()
    }, [])

    return (
        <Community>
            <div className="board_info_wrap">
                <div className="board_wrap_header">
                    <div className="board_wrap_header_exp">
                        <p>자유 커뮤니티</p>
                        <p className="small_phone_delete">
                            자유 커뮤니티 게시판입니다.
                            <br />
                            모욕·비방글은 무통보 삭제 및 이용 제재될 수
                            있습니다.
                        </p>
                    </div>
                </div>
                <div className="lineWidth"></div>

                <div className="board_info_content" style={{ whiteSpace: "pre-line", width: "100%" }}>
                    {noticeList?.length > 0 ? noticeList[0]?.desc : "공지사항이 없습니다."}
                </div>

                <div className="board_wrap_header">
                    <div></div>
                    <button
                        onClick={() => {
                            navigate(`/FreeCommunityWrite`);
                        }}
                    >
                        글쓰기
                    </button>
                </div>
                <div className="Job_search_offer_table">
                    <table>
                        <thead>
                            <tr>
                                <th className="small_delete" style={{ width: "10%" }} > 번호 </th>
                                <th style={{ width: "30%" }}>제목</th>
                                <th className="" style={{ width: "10%" }}> 작성자 </th>
                                <th className="small_delete" style={{ width: "10%" }} > 작성일 </th>
                                <th className="small_delete" style={{ width: "10%" }} > 조회수 </th>
                            </tr>
                        </thead>
                        <tbody>
                            {boardList.map((v, i) => {
                                return (
                                    <tr
                                        key={'board-it-' + i}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            navigate(
                                                `/FreeCommunityContent?idx=${v?.idx}`
                                            );
                                        }}
                                    >
                                        <td className="small_delete">{v?.idx}</td>
                                        <td className="td_title">
                                            <p>{v?.title}</p>
                                            {v?.commentCount ? <span> ({v?.commentCount})</span> : <></>}
                                        </td>
                                        <td className="td_writer ">
                                            <div className="text_box">
                                                <p>{v?.user?.compony?.title}</p>
                                                <p>{v?.user?.name} {v?.user?.rank}</p>
                                            </div>
                                        </td>
                                        <td className="small_delete">{moment(v?.create_dt).format("YYYY.MM.DD")}</td>
                                        <td className="small_delete">{v?.view}</td>
                                    </tr>
                                );
                            })}
                            {boardList?.length < 1 && <tr>
                                <td colSpan={5}>목록이 없습니다.</td>
                            </tr>}
                        </tbody>
                    </table>
                    <div className="PaginationContent">
                        <Pagination
                            className="my-pagination"
                            activePage={page} // 현제 보고있는 페이지
                            itemsCountPerPage={limit} // 한페이지에 출력할 아이템수
                            totalItemsCount={totalCount} // 총 아이템수
                            pageRangeDisplayed={10} // 표시할 페이지수
                            onChange={handlePageChange} // 함수
                            nextPageText=""
                            prevPageText=""
                            firstPageText=""
                            lastPageText=""
                        />
                    </div>
                    <div className="board_search_wrap">
                        <div className="asking_board_search">
                            <div className="custom-select">
                                <select value={dateType} onChange={e => setDateType(e.target.value)}>
                                    <option value={0}>전체기간</option>
                                    <option value={1}>최근 1주일</option>
                                    <option value={2}>최근 한달</option>
                                </select>
                            </div>

                            <div className="custom-select">
                                <select value={searchType} onChange={e => setSearchType(e.target.value)}>
                                    <option value={1}>제목</option>
                                    <option value={2}>번호</option>
                                    <option value={3}>작성자</option>
                                    {/* <option>사무소명</option> */}
                                </select>
                            </div>
                        </div>
                        <div className="search_input_wrap">
                            <Input
                                className={`inputs`}
                                type="text"
                                placeholder="검색어를 입력해주세요."
                                value={searchValue}
                                setValue={setSearchValue}
                            />
                            <button onClick={searchFunc}>검색</button>
                        </div>
                    </div>
                </div>
            </div>
        </Community>
    );
};
export default FreeCommunity;
